import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=64815b06&"
import script from "./ProductFilter.vue?vue&type=script&lang=js&"
export * from "./ProductFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports